import classNames from 'classnames'

import { Icon } from '@/Atomic/Atoms/Icon'

import './StepTimeline.scss'

interface StepTimelineProps {
  activeStep: number
  className?: string
  isStepClickable?: (step: number) => boolean
  onStepClick?: (step: number) => void
  steps: string[]
}

export const StepTimeline: React.FC<StepTimelineProps> = ({
  activeStep,
  className,
  isStepClickable,
  onStepClick,
  steps,
}) => {
  return (
    <div className={classNames('step-timeline', className)}>
      {steps.map((title, index) => {
        const isCompleted = index < activeStep
        const isActive = index === activeStep
        const canClick =
          Boolean(onStepClick) && Boolean(isStepClickable?.(index))
        const itemClassName = classNames('step-timeline__item', {
          'is-active': isActive,
          'is-clickable': canClick,
          'is-completed': isCompleted,
        })
        const itemContent = (
          <>
            <div className="step-timeline__track">
              <div className="step-timeline__dot">
                {isCompleted ? (
                  <Icon
                    icon="check"
                    size="sm"
                    className="step-timeline__dot-icon"
                  />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              {index < steps.length - 1 && (
                <div className="step-timeline__line" />
              )}
            </div>
            <span className="step-timeline__label">{title}</span>
          </>
        )

        if (!onStepClick) {
          return (
            <div className={itemClassName} key={`${index}-${title}`}>
              {itemContent}
            </div>
          )
        }

        return (
          <button
            type="button"
            className={itemClassName}
            aria-current={isActive ? 'step' : undefined}
            disabled={!canClick}
            key={`${index}-${title}`}
            onClick={() => onStepClick(index)}
          >
            {itemContent}
          </button>
        )
      })}
    </div>
  )
}
